import { MaAssetEntityTypeEnum } from '@/types/GraphqlSchema';
import type { EntitySelection } from './portfolioBridgeStore';

export const updateStats = (entities: EntitySelection[]) => {
  const totalAssets = entities.filter(e => e.type === MaAssetEntityTypeEnum.Asset).length;
  const totalBlocks = entities.filter(e => e.type === MaAssetEntityTypeEnum.Block).length;
  const totalFields = entities.filter(e => e.type === MaAssetEntityTypeEnum.Field).length;
  const total = entities.length;

  return { totalAssets, totalBlocks, totalFields, total };
};
